import React from "react";
import ourRecordsFront from "../../../assets/Group 159.svg"; // adjust path as needed
import "./records.scss";
import { Zoom,Slide } from "react-awesome-reveal";
const OurRecords = () => {
  return (
    <div className="our_records">
      <div className="container">
        <div className="row">
          <div className="records">
            <Zoom>
            <h3>Our Records</h3>
            </Zoom>
          </div>

          <div className="col-lg-6">
            <div className="our_recordsImage" style={{ position: "relative" }}>
              <img
                src={ourRecordsFront}
                alt="Our Records"
                style={{ objectFit: "cover", width: "100%" }}
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="our_records_content">
              <Slide direction="right" cascade damping={0.2}>
              <div className="row">
                <span>1</span>
                <div className="first">
                  <h3>Raised Fund</h3>
                  <p>
                    Successfully secured Rs 5,000 crore from banks, financial
                    institutions, NBFCs, and private equity to date.
                  </p>
                </div>
              </div>

              <div className="row">
                <span>2</span>
                <div className="first">
                  <h3>Restructured Debt</h3>
                  <p>
                    Restructured debt amounting to INR 1 lakh Cr since VCPL's
                    inception.
                  </p>
                </div>
              </div>

              <div className="row">
                <span>3</span>
                <div className="first">
                  <h3>Ticket Services</h3>
                  <p>
                    Maintaining flexibility, VCPL caters to a diverse clientele
                    with an average ticket size ranging from INR 50 Cr to INR
                    10,000 Cr, serving both SMEs and large corporations.
                  </p>
                </div>
              </div>

              <div className="row">
                <span>4</span>
                <div className="first">
                  <h3>CIRP Resolution</h3>
                  <p>
                    Resolved more than 2 lacs crores in lenders dunes under
                    Bankruptcy Code (IBC)
                  </p>
                </div>
              </div>
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurRecords;
